import { buildCollection, buildProperty } from "@firecms/core";
import { HomeButton } from "../components/HomeButton";

export type AnalyticsEvent = {
    user_id: number;
    event_type: string;
    created_at: Date;
    quota_type?: string;
    subscription_tier?: string;
    source?: string;
};

export const eventsCollection = buildCollection<AnalyticsEvent>({
    id: "events",
    name: "Events",
    singularName: "Event",
    path: "events",
    icon: "Timeline",
    group: "Analytics",
    Actions: HomeButton,
    description: "User interaction events for analytics (paywall views, button taps)",
    permissions: {
        edit: false,
        create: false,
        delete: false,
    },
    properties: {
        user_id: buildProperty({
            name: "User ID",
            dataType: "number",
            readOnly: true,
        }),
        event_type: buildProperty({
            name: "Event Type",
            dataType: "string",
            enumValues: {
                paywall_shown: "🚫 Paywall Shown",
                paywall_tapped_upgrade: "⬆️ Tapped Upgrade",
                paywall_tapped_booster: "⚡ Tapped Booster",
            },
            readOnly: true,
        }),
        quota_type: buildProperty({
            name: "Quota Type",
            dataType: "string",
            enumValues: {
                text: "📝 Text",
                voice: "🎤 Voice",
            },
            readOnly: true,
        }),
        subscription_tier: buildProperty({
            name: "Subscription Tier",
            dataType: "string",
            enumValues: {
                free: "Free",
                pro: "⭐ Pro",
                premium: "💎 Premium",
            },
            readOnly: true,
        }),
        source: buildProperty({
            name: "Source",
            dataType: "string",
            description: "Where the event was triggered (roleplay, study, etc.)",
            readOnly: true,
        }),
        created_at: buildProperty({
            name: "Date",
            dataType: "date",
            mode: "date_time",
            readOnly: true,
        }),
    },
    propertiesOrder: ["user_id", "event_type", "quota_type", "subscription_tier", "source", "created_at"],
});
